export function getQueryParam(name: string, url: string = window.location.href): string | null {
  const params = new URL(url).searchParams;
  return params.get(name);
}

export function setQueryParam(key: string, value: string, url: string = window.location.href): string {
  const updatedUrl = new URL(url);
  updatedUrl.searchParams.set(key, value);
  return updatedUrl.toString();
}

export function removeQueryParam(key: string, url: string = window.location.href): string {
  const updatedUrl = new URL(url);
  updatedUrl.searchParams.delete(key);
  return updatedUrl.toString();
}

export function getAllQueryParams(url: string = window.location.href): Record<string, string> {
  const params = new URL(url).searchParams;
  const paramObject: Record<string, string> = {};
  params.forEach((value, key) => {
    paramObject[key] = value;
  });
  return paramObject;
}
